<template>
  <div>
    <div class="m-search-result-header">
      <div class="container">
        <h1 class="m-search-result-header__headline">
          <span v-if="query">
            {{ $t('SearchShowingResultsFor', 'Viser resultater for') }} "{{ query }}"
          </span>
          <span v-else>
            {{ $t('SearchNoResults', 'Ingen resultater fundet') }}
          </span>
        </h1>
        <h2 class="m-search-result-header__subline">
          <span v-if="query">
            {{ $t('SearchFound', 'Vi fandt') }} {{ total }} {{ $t('SearchFoundResultsFor', 'resultater for søgningen') }} "{{ query }}"
          </span>
        </h2>
      </div>
    </div>

    <div class="m-search-result-tabs">
      <button class="m-search-result-tabs__tab" :class="{ '-active': currentTab===0 }" @click="currentTab=0">
        {{ $t('Products', 'Produkter') }} <span v-if="query && productResults" class="m-search-result-tabs__total">({{ productResults.totalItems }})</span>
      </button>
      <button class="m-search-result-tabs__tab" :class="{ '-active': currentTab===1 }" @click="currentTab=1">
        {{ $t('Articles', 'Artikler') }} <span v-if="query" class="m-search-result-tabs__total">({{ articleResultsTotal }})</span>
      </button>
      <button class="m-search-result-tabs__tab" :class="{ '-active': currentTab===2 }" @click="currentTab=2">
        {{ $t('Catalogs', 'Kataloger') }} <span v-if="query" class="m-search-result-tabs__total">({{ catalogResultsTotal }})</span>
      </button>
    </div>

    <div class="pt-4 pb-10">
      <div v-if="query" class="container">
        <div v-show="currentTab===0" class="m-search-result-tabs__content">
          <search-result-products />
        </div>
        <div v-show="currentTab===1" class="m-search-result-tabs__content">
          <search-result-content
            :spots="articleResults"
          />
        </div>
        <div v-show="currentTab===2" class="m-search-result-tabs__content">
          <search-result-content
            :spots="catalogResults"
          />
        </div>
      </div>
    </div>
    <search-previous />
    <section
      v-for="(contentElement, i) in content.nestedContent"
      :key="contentElement.key"
      :class="[getSpacingVertical(contentElement),
               getElementTemplate(contentElement) ? getSpacingTopClass(contentElement) + ' ' + getSpacingBottomClass(contentElement) : null ]"
    >
      <component
        :is="getElementTemplate(contentElement)"
        v-if="getElementTemplate(contentElement)"
        :content="contentElement"
        :parent-id="content.parent"
        :is-first="i === 0"
      />
    </section>
  </div>
</template>

<script>
import elementResolverMixin from '@/mixins/elementResolverMixin';
import SearchResultProducts from '@/components/organisms/ShopCommerce/SearchResultProducts';
import SearchResultContent from '@/components/organisms/SearchResultContent';
import SearchPrevious from '@/components/molecules/SearchPrevious';
import { getSpotsByTemplate } from '@/utils/spots'
import {
  getSpacingTopClass,
  getSpacingBottomClass
} from '@/utils/spacing-classes.js';

export default {
  name: 'SearchPage',
  components: {
    SearchPrevious,
    SearchResultProducts,
    SearchResultContent
  },
  mixins: [elementResolverMixin],
  data () {
    return {
      currentTab: 0,
      query: this.$route.query?.query,
    }
  },
  computed: {
    productResults () {
      return this.$store.getters['search/productSearch/getProducts']
    },
    contentResults () {
      return this.$store.getters['content/contentSearch/getResult'];
    },
    articleResults () {
      return this.getSpotsByTemplate(this.contentResults, ['project', 'recipe', 'event']);
    },
    catalogResults () {
      return this.getSpotsByTemplate(this.contentResults, ['catalogPage']);
    },
    articleResultsTotal () {
      return this.articleResults?.items ? this.articleResults?.items.length : 0;
    },
    catalogResultsTotal () {
      return this.catalogResults?.items ? this.catalogResults?.items.length : 0;
    },
    total () {
      return this.articleResultsTotal + this.catalogResultsTotal + this.productResults.totalItems;
    },
    culture () {
      return this.$store.getters['site/getCurrentCulture']
    },
  },
  created () {
    this.$store.dispatch('content/contentSearch/fetchResult', {
      query: this.query,
      template: '', // Empty means return all types
      culture: this.culture,
      itemsPerPage: 12,
      currentPage: 1
    })
  },
  methods: {
    getSpacingTopClass,
    getSpacingBottomClass,
    getSpotsByTemplate,
  }
};
</script>